import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getDefectById, updateDefect } from "../../services/api";
import Breadcrumbs from "../../components/BreadCrumbs";

const DefectUpdate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [descripcion, setDescripcion] = useState("");
  const [testData, setTestData] = useState({
    nombre: "",
    descripcion: "",
    asignado_a: "",
    estado: "",
    caso_prueba_id: "",
  });

  useEffect(() => {
    const fetchDefect = async () => {
      try {
        const response = await getDefectById(id);
        setTestData(response);
      } catch (error) {
        console.error("Error al obtener el defecto", error);
      }
    };

    fetchDefect();
  }, [id]);

  const handleChange = (e) => {
    setTestData({
      ...testData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateDefect(id, testData);
      navigate("/defects");
    } catch (error) {
      console.error("Error al actualizar el defecto", error);
    }
  };

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Projects", url: "/dashboard/projects" },
    { name: "Test", url: "/dashboard/projects/1/test" },
  ];

  return (
    <>
      <h2>Actualizar Defecto</h2>
      <Breadcrumbs paths={breadcrumbPaths} />
      <form onSubmit={handleSubmit}>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">
            Nombre del Caso de Prueba
          </label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="nombre"
              value={testData.nombre}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Descripción</label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              value={testData.descripcion}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Asignado a</label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="assignedTo"
              value={testData.asignado_a}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Estado</label>
          <div class="col-sm-10">
            <select
              className="form-select"
              name="estado"
              value={testData.estado}
              onChange={handleChange}
              required
            >
              <option value="">Seleccionar...</option>
              <option value="Abierto">Abierto</option>
              <option value="En progreso">En progreso</option>
              <option value="Resuelto">Resuelto</option>
            </select>
          </div>
        </div>
        <div style={{ textAlign: "end" }}>
          <button type="submit" className="btn btn-primary">
            Actualizar
          </button>
        </div>
      </form>
    </>
  );
};

export default DefectUpdate;
